<template>
  <span class="print-view">
    <div class="btn-group text-center my-4">
        <vs-button class="mx-1 my-1" type="filled" @click="fetchCustomerListForSend">Send Credit Note</vs-button>
        <vs-button class="mx-1 my-1" type="filled" @click="onClickPrint">Print & Download</vs-button>
    </div>
    <page id="printDiv" size="A4" >
       <div class="vx-row mb-0">
         <div class="vx-col w-full">

          <main class="clearfix">
            <div id="user" class="clearfix">

            <div id="user-top">

              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>
                <tr>
                  <td class="head align-left">
                    <img id="logo"
                         src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                         alt="Logo" width="300" height="150" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <table id="in-tbl">
                      <thead class="">
                      <tr>
                        <td colspan="2" class="head">
                          <h4 class="m-0" style="color: #000000"><b>CREDIT NOTE</b></h4>
                        </td>
                      </tr>
                      </thead>

                      <tbody>

                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">SHIPPER/EXPORTER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.shipper_address.company_name }}<br>
                                    {{ invoice_data.shipper_address.line_1 }}<br>
                                    {{ invoice_data.shipper_address.line_2 }}<br>
                                    {{ invoice_data.shipper_address.town_state }}<br>
                                    {{ invoice_data.shipper_address.post_code }}<br>
                                    {{ invoice_data.shipper_address.country }}</p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                    Email: {{ invoice_data.email || '' }}<br>
                                    VAT Reg No: {{ invoice_data.vat_reg || '' }}<br>
                                    Company No: {{ invoice_data.company_no || '' }}<br>
                                    EORI for NL: {{ invoice_data.eori_ni || '' }}<br>
                                    EORI for EU: {{ invoice_data.eori_eu || '' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">DATE OF CREDIT:</p>
                                  <p class="sml"><b>{{ invoice_data.note_date || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">CREDIT NOTE NO:</p>
                                  <p class="sml"><b>{{ invoice_data.note_number || '' }}</b></p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER P.O. NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_order_number || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">ITS ORDER NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.order_code || ''  }}</b></p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE/RECEIVER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.customer_address.company_name }}<br>
                                    {{ invoice_data.customer_address.line_1 }}<br>
                                    {{ invoice_data.customer_address.line_2 }}<br>
                                    {{ invoice_data.customer_address.town_state }}<br>
                                    {{ invoice_data.customer_address.post_code }}<br>
                                    {{ invoice_data.customer_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">
                                    VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                    EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                    TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td class="htd">
                                <div style="height: 165px;">
                                  <p class="sml">CUSTOMER ACCOUNT NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_account_number || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TRANSPORT AWB/REF NUMBER:</p>
                                  <p class="sml"><b>{{  invoice_data.transport_ref_number }}</b></p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">DELIVERY SITE</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytd">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.delivery_address.company_name }}<br>
                                    {{ invoice_data.delivery_address.line_1 }}<br>
                                    {{ invoice_data.delivery_address.line_2 }}<br>
                                    {{ invoice_data.delivery_address.town_state }}<br>
                                    {{ invoice_data.delivery_address.post_code }}<br>
                                    {{ invoice_data.delivery_address.country }}</p>
                                </div>
                              </td>

                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-l-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">FREIGHT DETAILS:</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" style="height: 145px;">
<!--                                <div>-->
                                <!--                                  <p class="sml">(ITS) International Taste-->
                                <!--                                    Solutions<br>-->
                                <!--                                    Innovation House<br>-->
                                <!--                                    Abex Road<br>-->
                                <!--                                    Newbury, Berkshire<br>-->
                                <!--                                    RG145EY<br>-->
                                <!--                                    United Kingdom</p>-->
                                <!--                                </div>-->
                              </td>
                              <td class="bodytdb">
<!--                                <div>-->
                                <!--                                  <p class="sml">Tel. 01635 261920<br>-->
                                <!--                                    Email: sales@itstaste.com<br>-->
                                <!--                                    VAT Reg No: 1234567890<br>-->
                                <!--                                    Company No: 1234567890<br>-->
                                <!--                                    EORI for NL: XI1234567890<br>-->
                                <!--                                    EORI for EU: GB1234567890</p>-->
                                <!--                                </div>-->
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td colspan="2" class="toptd">
                          <table id="content-tbl">
                            <thead>
                            <tr v-if="!is_only_contain_additional_cost">
                              <th colspan="3"><b>Customer Product Code</b></th>
                               <th colspan="3"><b>Product Code/Name</b></th>
                               <th colspan="3" ><b>Quantity (KG)</b></th>
                              <th colspan="3" ><b>Batch Number</b></th>
                              <th colspan="3" ><b>Commodity Code</b></th>
                              <th colspan="3" ><b>Price Per Unit ({{invoice_data.customer_currency}}) </b></th>
                              <th colspan="3" ><b>Net Value ({{invoice_data.customer_currency}})</b></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in invoice_data.belongs_to_product_items" :key="index" v-if="!is_only_contain_additional_cost">

                              <td colspan="3">
                                {{ item.customer_product_code }}
                              </td>
                              <td colspan="3">
                                {{ item.formulation_code }}
                              </td>
                              <td colspan="3">                            
                                <span v-if="item.batches.length > 0" v-for="(batch, batch_index) in item.batches" :key="batch_index">
                                  {{ batch.quantity }} <br>
                                </span>
                                <span v-if="item.batches.length === 0">
                                  {{ item.total_quantity }}
                                </span>
                              </td>
                              <td colspan="3">   
                                <span v-if="item.batches.length > 0" v-for="(batch, batch_index) in item.batches" :key="batch_index">
                                  {{ batch.work_order_code }}
                                </span>
                                <span v-if="item.batches.length === 0">N/A</span>
                              </td>
                              <td colspan="3"> 
                                <span>
                                  {{ item.commodity_code || 'N/A' }}
                                </span>
                              </td>
                              <td colspan="3">
                                {{ item.unit_price }}
                              </td>
                              <td colspan="3">
                                {{ calculateRowNetValue(item) }}
                              </td>


                            </tr>
                                                       <tr v-if="!is_only_contain_additional_cost">
                                                         <!-- <td colspan="15"></td> -->
                                                         <td colspan="20">Items Net Value (Excl. VAT in {{ invoice_data.customer_currency }})</td>
                                                         <td>{{totalCnItem()}}</td>
                                                       </tr>
                                                       <tr v-for="(cost, index_cost) in invoice_data.additional_cost" :key="index_cost">
                                                         <!-- <td colspan="15"></td> -->
                                                         <td colspan="20">{{ cost.name }} ({{ cost.vat_percent }}% VAT/Tax)</td>
                                                         <td>{{ Number(((cost.amount / 100 ) * (100 + Number(cost.vat_percent)))).toFixed(2) }}</td>
                                                       </tr>
                                                       <tr>
                                                         <!-- <td colspan="15"></td> -->
                                                         <td colspan="20">Total Order Value (Incl. VAT in {{ invoice_data.customer_currency }})</td>
                                                         <td>{{ totalCn() }}
                                                        </td>
                                                       </tr>
                            </tbody>
                          </table>
                        </td>

                      </tr>

                      <tr>
                        <td colspan="2" class="toptd">

                          <table class="no-bd-tbl">
                            <thead>
                            <tr>
                              <td colspan="4">
                                <p>
                                  <br>
                                  The exporter of the products covered by this<br>
                                  document declares that, except where<br>
                                  otherswise clearly indicated, these products
                                  are<br>
                                  of the UK preferential origin<br>
                                  <b>Products: Not edible, Not animal origin
                                  </b>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2" width="750px">
                                <p>Payment Details<br>
                                  Sterling Electronic Payments:-<br>
                                  Bank: {{ invoice_data.bank_details.name }}<br>
                                  Account Name: {{ invoice_data.bank_details.account_name }}<br>
                                  Account Number: {{ invoice_data.bank_details.account_number }} Sort Code: {{ invoice_data.bank_details.sort_code || 'N/A' }}<br>
                                  IBAN: {{ invoice_data.bank_details.iban || 'N/A' }}<br>
                                  SWIFTBIC: {{ invoice_data.bank_details.swiftbi || 'N/A' }}</p>

                              </td>
                              <td>
<!--                                <img width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/s_jones_signature.png" alt="">-->
                              </td>
                              <td>
<!--                                <img width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/its_stamp.bmp" alt="">-->
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4">
                                <p class="align-center">ITS reserves the right to
                                  charge
                                  interest on late payments<br>
                                  ITS terms and conditions of sale apply.</p>
                              </td>
                            </tr>
                            </thead>
                          </table>
                        </td>

                      </tr>


                      </tbody>
                    </table>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </main>
         </div>
       </div>
    </page>
    <vs-prompt
      @cancel="customer_email=''"
      @accept="onClickSendCreditNote"
      @close="activeEmailSelectPrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activeEmailSelectPrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_users_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.job_title || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>
  </span>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import vSelect from 'vue-select'
const CustomerRepository = RepositoryFactory.get('customer')
const DropDownRepository = RepositoryFactory.get('drop_down')

export default {
  name: "CustomerCreditNotePrintView",
  data(){
    return {
      secret_code: null,
      invoice_data: {},
      activeEmailSelectPrompt: false,
      customer_email: '',
      customer_users_list: '',
      credit_note_id: '',
    }
  },
  async mounted() {
    this.secret_code = this.$route.params.secret_code
    this.credit_note_id = this.$route.params.id
    await this.getCreditNoteData()
  },
  components: {
    'v-select': vSelect,
  },
  methods:{
    async getCreditNoteData() {
      await this.$vs.loading()
      try {
        const {data} = (await CustomerRepository.getCreditNotePdfData(this.secret_code))
        this.invoice_data =  data
        this.invoice_data.order_items = []
        this.invoice_data.additional_costs = []
        this.invoice_data.belongs_to_product_items = data.belongs_to_product_items.filter((x) => {
          return Number(x.total_quantity) > 0
        })
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close()
    },
    async fetchCustomerListForSend() {
      try {
        const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.invoice_data.customer_id)).data
        this.customer_users_list = data
      } catch (e) {

      }
      this.activeEmailSelectPrompt = true
    },
    async onClickSendCreditNote() {
      try {
        this.activeEmailSelectPrompt = false
        // await CustomerRepository.sendCustomerCreditNote(this.invoice_data.id, { user_email: this.customer_email })
        await CustomerRepository.sendCustomerCreditNote(this.credit_note_id, { user_email: this.customer_email })
        this.customer_email = ''
        this.showSuccessMessage('Credit Note sent successfully')
      } catch (e) {
      }
    },
    onClickPrint(){
      window.print()
    },
    styleObject: function () {
      const total_item_height = this.invoice_data.belongs_to_product_items.length * 55
      const total_add_cost_line_height =  this.invoice_data.additional_costs.length * 100
      const space_height = 400 - (total_item_height + total_add_cost_line_height)
      return {
        height: `${space_height}px`
      }
    },
    calculateRowNetValue(tr) {
      if(tr.batches.length === 0) {
        return Number(tr.unit_price * tr.total_quantity).toFixed(2)
      } else {
        return Number(tr.batches.reduce((a, c) => a + (Number(c.quantity) * Number(tr.unit_price)), 0)).toFixed(2)
      }
    },
    totalCn() {
      let total = 0
      let total_add_cost = 0
      this.invoice_data.belongs_to_product_items.forEach((x) => {
        let line_total = this.calculateRowNetValue(x)
        total = total + Number(line_total)
      })
      this.invoice_data.additional_cost.forEach((x) => {
        let line_add_cost = (x.amount / 100) * (100 + Number(x.vat_percent))
        total_add_cost = total_add_cost + line_add_cost
      })
      return Number(total_add_cost + total).toFixed(2)
    },
    totalCnItem() {
      let total = 0
      this.invoice_data.belongs_to_product_items.forEach((x) => {
        let line_total = this.calculateRowNetValue(x)
        total = total + Number(line_total)
      })
      return Number(total).toFixed(2)
    }
  },
  computed: {
    is_only_contain_additional_cost: function () {
      const total = this.totalCnItem()
      return 0 === Number(total)
    }
  }
}
</script>

<style lang="scss">

@media print {
  body {
    zoom: 80%;
  }
}
//.ordered_list { counter-reset: item }
//.list_item { display: block }
//.list_item:before { content: counters(item, ".") " "; counter-increment: item}

.termsText > td > p {
  font-size: 11px;
  line-height: 12px;
}

page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
  width: 30cm;
  height: auto;
}

@media print {
  .print-view {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}


html,
body {
  -webkit-print-color-adjust: exact !important;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000 !important;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  background-color: #FFFFFF !important;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
  color: #000000 !important;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 10px;
  text-align: center;
  vertical-align: top;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
  color: #000;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 5em auto 2em auto;
}

div#user-top table {
  margin: 0 auto .8em auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 8px;
  font-size: 18px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;
}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 300px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}

</style>
